import { hexToRgb } from '@material-ui/core'

const appendAlphaChannelToRgbString = (rgb: string, alpha: number | string) => {
  const rgba = rgb.slice(0, 3).concat('a')
  const values = rgb.slice(3, rgb.length - 1).concat(`, ${alpha})`)

  return rgba.concat(values)
}

export default (hex: string, alpha?: number | string) => {
  const rgb = hexToRgb(hex)

  return alpha ? appendAlphaChannelToRgbString(rgb, alpha) : rgb
}
